import React, { useEffect, useState } from "react";

import ConfirmationModal from "@enerex/unified-ui-react/ConfirmationModal";
import FormInput from "@enerex/unified-ui-react/form/FormInput";
import { useForm } from "react-hook-form";


import ElectricityIcon from "@enerex/unified-ui-react/icons/ElectricityIcon";
import GasIcon from "@enerex/unified-ui-react/icons/GasIcon";

import { getStateDisplayName, getStateOptionValue } from "../utilityUtils";
import "./RateClassModal.css";


const defaults = { CommodityId: 1, RateClass: "", IsResidential: false };

const RateClassModal = ({ show, record, onHide, onSave, states = [], saving }) => {
  const [form, setForm] = useState(defaults);
  const { control, reset, setValue } = useForm({ defaultValues: { CommodityId: 1, State: null, RateClass: null } });

  useEffect(() => {
    if (!show) return;
    const next = record ? {
      Id: record.id ?? record.Id ?? 0,
      UtilitiesId: record.utilitiesId ?? record.UtilitiesId ?? record.utilityId ?? record.UtilityId ?? 0,
      CommodityId: Number(record.commodityId ?? record.CommodityId ?? 1),
      RateClass: record.rateClass || record.RateClass || record.rateClassName || record.RateClassName || "",
      IsResidential: Boolean(record.isResidential ?? record.IsResidential),
      StateId: record.stateId ?? record.StateId,
    } : defaults;
    setForm(next);
    reset({ CommodityId: next.CommodityId, State: null, RateClass: next.RateClass });
  }, [show, record, reset]);

  const stateOptions = states.map((state) => ({ value: getStateOptionValue(state), label: getStateDisplayName(state) }));
  const selectedState = stateOptions.find((state) => String(state.value) === String(form.StateId)) || stateOptions[0] || null;

  const selectedStateId = selectedState?.value;
  const selectedStateLabel = selectedState?.label;
  useEffect(() => {
    setValue("State", selectedStateId == null ? null : { value: selectedStateId, label: selectedStateLabel });
  }, [show, selectedStateId, selectedStateLabel, setValue]);

  return (
    <ConfirmationModal
      dialogClassName="utility-rate-class-dialog"
      centered
      show={show}
      onHide={onHide}
      title={record ? "Edit Rate Class" : "Rate Class"}
      confirmButtonLabel={saving ? "Saving..." : record ? "Save" : "Add Rate Class"}
      confirmButtonVariant="primary"
      isLoading={saving}
      onConfirm={() => {
        if (!selectedStateId || !form.RateClass.trim()) return;
        onSave({ ...form, RateClass: form.RateClass.trim(), StateId: selectedStateId });
      }}
    >
      <div className="utility-rate-class-fields">
      <FormInput
        containerClass="utility-rate-class-commodity"
        type="radio-group"
        name="CommodityId"
        control={control}
        inline
        disabled={saving}
        options={[
          { id: "rate-class-electric", value: 1, label: <ElectricityIcon />, title: "Electric" },
          { id: "rate-class-gas", value: 2, label: <GasIcon />, title: "Natural Gas" },
        ]}
        onChange={(value) => setForm((current) => ({ ...current, CommodityId: Number(value) }))}
      />
      <FormInput
        containerClass="utility-rate-class-field"
        labelClassName="utility-rate-class-label"
        type="select"
        name="State"
        control={control}
        label="State *"
        inputId="utility-rate-class-state"
        aria-label="State"
        options={stateOptions}
        disabled
        getOptionValue={(option) => String(option.value)}
        getOptionLabel={(option) => option.label}
        placeholder="No state of operation available"
      />
      <FormInput
        containerClass="utility-rate-class-field"
        labelClassName="utility-rate-class-label"
        type="text"
        name="RateClass"
        control={control}
        label="Rate Class Name *"
        id="utility-rate-class-name"
        value={form.RateClass}
        onChange={(event) => setForm((current) => ({ ...current, RateClass: event.target.value }))}
        placeholder="Enter rate class name"
        disabled={saving}
      />
      <label className="utility-rate-class-residential">
        <input
          type="checkbox"
          name="IsResidential"
          checked={form.IsResidential}
          onChange={(event) => setForm((current) => ({ ...current, IsResidential: event.target.checked }))}
          disabled={saving}
        />
        Is Residential
      </label>
      </div>
    </ConfirmationModal>
  );
};

export default RateClassModal;
